const API_BASE = '/api/v1';

async function request(path) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    const error = new Error(`Request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export function apiLocale(locale) {
  return locale === 'en' ? 'en-US' : 'zh-CN';
}

export function getPublicCategories() {
  return request('/public/categories');
}

export function getPublicNews(locale, page = 1, pageSize = 10, categoryId) {
  const params = new URLSearchParams({
    locale: apiLocale(locale),
    page: String(page),
    pageSize: String(pageSize),
  });
  if (categoryId) {
    params.set('categoryId', String(categoryId));
  }
  return request(`/public/news?${params.toString()}`);
}

export function getPublicNewsDetail(slug, locale) {
  const params = new URLSearchParams({ locale: apiLocale(locale) });
  return request(`/public/news/${encodeURIComponent(slug)}?${params.toString()}`);
}

export function getSiteSettings(locale) {
  const params = new URLSearchParams({ locale: apiLocale(locale) });
  return request(`/public/site-settings?${params.toString()}`);
}
